import script from "./CheckTemplateFormOne.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckTemplateFormOne.vue?vue&type=script&setup=true&lang=js"

import "./CheckTemplateFormOne.vue?vue&type=style&index=0&id=0153e8b4&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0153e8b4"]])

export default __exports__